import type { Theme, SxProps } from '@mui/material/styles';

import React from 'react';
import { m } from 'framer-motion';
import { useNavigate } from 'react-router-dom';

import { Button } from '@mui/material';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import ArrowBackOutlinedIcon from '@mui/icons-material/ArrowBackOutlined';

import { ForbiddenIllustration } from 'src/assets/illustrations';

import { varBounce, MotionContainer } from 'src/components/animate';

import type { RoleUser } from '../types';

export type RoleBasedGuardProp = {
  sx?: SxProps<Theme>;
  currentRole: RoleUser;
  acceptRoles: RoleUser[];
  children: React.ReactNode;
  hasContent?: boolean;
};

export function RoleBasedGuard({
  sx,
  children,
  hasContent = false,
  currentRole,
  acceptRoles,
}: RoleBasedGuardProp) {
  const isAllowed = typeof acceptRoles === 'undefined' || acceptRoles.includes(currentRole);
  const navigate = useNavigate();

  if (!isAllowed) {
    if (hasContent) {
      return (
        <Container component={MotionContainer} sx={{ textAlign: 'center', ...sx }}>
          <m.div variants={varBounce().in}>
            <Typography variant="h3" sx={{ mb: 2 }}>
              Quyền bị từ chối
            </Typography>
          </m.div>

          <m.div variants={varBounce().in}>
            <Typography sx={{ color: 'text.secondary' }}>
              Bạn không có quyền truy cập trang này.
            </Typography>
          </m.div>

          <m.div variants={varBounce().in}>
            <ForbiddenIllustration sx={{ my: { xs: 5, sm: 10 } }} />
          </m.div>
          <m.div variants={varBounce().in}>
            <Button
              onClick={() => navigate(`/${currentRole}`)}
              type="button"
              variant="contained"
              startIcon={<ArrowBackOutlinedIcon />}
            >
              Quay lại trang chủ
            </Button>
          </m.div>
        </Container>
      );
    }
  }

  return <>{children}</>;
}
